<template>
    <div class='card'>
        <div class='card-body'>
            <h5 class="mb-0">Standards & Correlations</h5>
            <small>Will automatically link the selected states SS & SN publications</small>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.form-control {
    min-height: 2.5rem;
}
</style>

<script>
export default {
    name: 'Standards',
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>
